import { MouseEventHandler, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAktiviereAbzurechnendeDienstleistungMutation, useDeaktiviereAbzurechnendeDienstleistungMutation, useGetDlMutation } from '../../api/FakturaAPI';
import { formatToEuroDate } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import { IAbrechenbareDienstleistungenFilter, IFakturaDlResponseDto } from '../../types/Types';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';

export default function ListeAbrechenbareDienstleistungen() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [getDlAPI] = useGetDlMutation();
    const [aktiviereAdlAPI] = useAktiviereAbzurechnendeDienstleistungMutation();
    const [deaktiviereAdlAPI] = useDeaktiviereAbzurechnendeDienstleistungMutation();

    const [auftraege, setAuftraege] = useState<IFakturaDlResponseDto[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [filter, setFilter] = useState<IAbrechenbareDienstleistungenFilter>({
        erledigtVon: undefined,
        erledigtBis: undefined,
        terminVon: undefined,
        terminBis: undefined,
        nurAbrechenbar: true,
        nurAbgerechnete: false,
        nurAktive: true,
        nurInAktive: false,
    });

    const lade = () => {
        setIsLoading(true);
        getDlAPI(filter).unwrap()
            .then((data) => setAuftraege(data))
            .catch((error) => console.error(error))
            .finally(() => setIsLoading(false))
            ;

    }

    const handleInputText = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    }


    const handleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.checked
        });
    }

    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        lade();
    }

    const deaktiviereAdl = (uid: string) => {
        deaktiviereAdlAPI(uid).unwrap()
            .then(() => lade())
            .catch((error) => console.error(error))
            ;
    }

    const aktiviereAdl = (uid: string) => {
        aktiviereAdlAPI(uid).unwrap()
            .then(() => lade())
            .catch((error) => console.error(error))
            ;
    }

    useEffect(() => {
        if (filter.nurAktive === false) return;
        if (filter.nurAktive === true && filter.nurInAktive === true) { setFilter({ ...filter, nurInAktive: false }); return; }
    }, [filter.nurAktive]);

    useEffect(() => {
        if (filter.nurInAktive === false) return;
        if (filter.nurInAktive === true && filter.nurAktive === true) { setFilter({ ...filter, nurAktive: false }); return; }
    }, [filter.nurInAktive]);

    useEffect(() => {
        if (filter.nurAbrechenbar === false) return;
        if (filter.nurAbrechenbar === true && filter.nurAbgerechnete === true) { setFilter({ ...filter, nurAbgerechnete: false }); return; }
    }, [filter.nurAbrechenbar]);

    useEffect(() => {
        if (filter.nurAbgerechnete === false) return;
        if (filter.nurAbgerechnete === true && filter.nurAbrechenbar === true) { setFilter({ ...filter, nurAbrechenbar: false }); return; }
    }, [filter.nurAbgerechnete]);

    return (
        <>
            <div>

                <LoadingModal show={isLoading} />

                <LandingpageHeader />

                <div style={{ padding: "20px" }}>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <button
                            onClick={() => {
                                navigate({
                                    pathname: "/",
                                    search: ""
                                });
                            }}

                            style={{ marginBottom: "20px" }}
                            className=' btn btn-outline-primary'
                        >
                            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                        </button>
                    </div>

                    <h3>Abrechenbare Dienstleistungen</h3>

                    <form onSubmit={submit} className="">

                        <h4>Filter</h4>

                        <div className="mb-3">
                            <label htmlFor="erledigtVon" className="form-label">Erledigt von</label>
                            <input type="date" className="form-control" name="erledigtVon" value={"" + filter.erledigtVon} onChange={handleInputText} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="erledigtBis" className="form-label">Erledigt bis</label>
                            <input type="date" className="form-control" name="erledigtBis" value={"" + filter.erledigtBis} onChange={handleInputText} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="terminVon" className="form-label">Termin von</label>
                            <input type="date" className="form-control" name="terminVon" value={"" + filter.terminVon} onChange={handleInputText} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="terminBis" className="form-label">Termin bis</label>
                            <input type="date" className="form-control" name="terminBis" value={"" + filter.terminBis} onChange={handleInputText} />
                        </div>

                        <div className="form-switch form-check">
                            <input type="checkbox" role="switch" className="form-check-input" name="nurAbrechenbar" checked={filter.nurAbrechenbar} onChange={handleCheckbox} />
                            <label className="form-check-label">Nur abrechenbare Dienstleistungen</label>
                        </div>

                        <div className="form-switch form-check">
                            <input type="checkbox" role="switch" className="form-check-input" name="nurAbgerechnete" checked={filter.nurAbgerechnete} onChange={handleCheckbox} />
                            <label className="form-check-label">Nur abgerechnete Dienstleistungen</label>
                        </div>

                        <div className="form-switch form-check">
                            <input type="checkbox" role="switch" className="form-check-input" name="nurAktive" checked={filter.nurAktive} onChange={handleCheckbox} />
                            <label className="form-check-label">Nur aktive Dienstleistungen</label>
                        </div>

                        <div className="form-switch form-check">
                            <input type="checkbox" role="switch" className="form-check-input" name="nurInAktive" checked={filter.nurInAktive} onChange={handleCheckbox} />
                            <label className="form-label">Nur inaktive Dienstleistungen</label>
                        </div>

                        <div className="form-group">
                            <button type="submit" className="btn btn-primary">Aktualisieren</button>
                        </div>
                    </form>

                    <p>
                        Anzahl {auftraege.length}
                    </p>

                    <table className="table">

                        <tr>
                            <th>Status</th>
                            <th>Auftragsstatus</th>
                            <th>Rechnungsempfänger</th>
                            <th>Text</th>
                            <th>Preis</th>
                            <th>Errechneter Preis</th>
                            <th>Auftragsnr AG</th>
                            <th>Erstellt am</th>
                            <th>Erledigtdatum</th>
                            <th>Termin</th>
                            <th>Option</th>
                        </tr>

                        {auftraege.map((e, index) => <>
                            <tr key={index}>
                                <td>{e.aktiv ? "Aktiv" : "Inaktiv"}</td>
                                <td>{e.auftragsStatus}</td>
                                <td>{e.auftraggeber.name}</td>
                                <td>{e.text}</td>
                                <td>{e.preis}</td>
                                <td>{e.errechneterPreis}</td>
                                <td>{e.auftragsnummer_ag}</td>
                                <td>{formatToEuroDate(e.erstelltAm)}</td>
                                <td>{formatToEuroDate(e.erledigtAm)}</td>
                                <td>{formatToEuroDate(e.termin)}</td>
                                <td>
                                    {e.aktiv && <button className="btn btn-outline-primary" onClick={() => deaktiviereAdl(e.uid)}>Deaktivieren</button>}
                                    {!e.aktiv && <button className="btn btn-outline-primary" onClick={() => aktiviereAdl(e.uid)}>Aktivieren</button>}
                                </td>
                            </tr>
                        </>)}

                    </table >

                </div>
            </div >
            <Footer />
        </>
    );
}
